<template>
  <button class="hamburgerMenu" :class="[isHamburgerCloseClass]" @click="handleNavMenuVisible" ref="hamburgerMenu">
    <span class="hamburgerMenu_item hamburgerMenu_item--top"></span>
    <span class="hamburgerMenu_item hamburgerMenu_item--middle"></span>
    <span class="hamburgerMenu_item hamburgerMenu_item--bottom"></span>
  </button>
</template>

<script>
export default {
  name: 'HambergerMenu',
  props: {
    isMenuVisible: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
    }
  },
  mounted () {},
  computed: {
    isHamburgerCloseClass () {
      return this.isMenuVisible ? 'hamburgerMenu--isClose' : ''
    }
  },
  methods: {
    handleNavMenuVisible () {
      this.$emit('handleNavMenuVisible')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/stylesheets/mixins';
@import '../../assets/stylesheets/variables';

.hamburgerMenu {
  $hamburgerMenu: #{&};
  @include bpOnlyPc() {
    width: 48px;
    height: 38px;
    top: 32px;
    right: 32px;
  }
  @include bpOnlySp() {
    width: 38px;
    height: 26px;
    top: 18px;
    right: 18px;
  }
  position: fixed;
  z-index: 100;
  mix-blend-mode: difference;
  &_item {
    @include bpOnlyPc() {
      height: 6px;
    }
    @include bpOnlySp() {
      height: 4px;
    }
    display: block;
    position: absolute;
    width: 100%;
    transform-origin: center;
    background-color: #fff;
    &--top {
      top: 0;
      transition: transform 0.5s ease;
      #{$hamburgerMenu}--isClose & {
        background-color: #fff;
        @include bpOnlyPc() {
          transform: translateY(16px) rotate(45deg);
        }
        @include bpOnlySp() {
          transform: translateY(11px) rotate(45deg);
        }
      }
    }
    &--middle {
      top: 0;
      bottom: 0;
      margin: auto;
      transition: opacity 0.5s ease;
      #{$hamburgerMenu}--isClose & {
        background-color: #fff;
        opacity: 0;
      }
    }
    &--bottom {
      bottom: 0;
      transition: transform 0.5s ease;
      #{$hamburgerMenu}--isClose & {
        @include bpOnlyPc() {
          transform: translateY(-16px) rotate(-45deg);
        }
        @include bpOnlySp() {
          transform: translateY(-11px) rotate(-45deg);
        }
        background-color: #fff;
      }
    }
  }
}
</style>
